import React from 'react';

import classNames from 'classnames';

import { formatPrice } from '@shared/helpers';

import cls from './ProfitForecastInformationBlock.module.css';
import { useProfitForecastInformationBlock } from './useProfitForecastInformationBlock';
import {
    FinancialIndicatorsInfoElement,
    FinancialInfoType,
} from '../../../UI/FinancialIndicatorsInfoElement/FinancialIndicatorsInfoElement';

interface ProfitForecastInformationBlockProps {
    classes?: string;
}

export const ProfitForecastInformationBlock = ({
    classes,
}: ProfitForecastInformationBlockProps) => {
    const { financial_info } = useProfitForecastInformationBlock();
    return (
        <div className={classNames(cls.ProfitForecastInformationBlock, [classes])}>
            <FinancialIndicatorsInfoElement
                title={i18next.t(
                    'ProfitForecastInformationBlock.return.financialIndicatorsInfoElement.title'
                )}
                value={formatPrice(Math.round(financial_info?.key_metrics?.profit_forecast_value), {
                    withCurrency: true,
                    currencySign: financial_info?.currency?.sign,
                })}
                // @ts-ignore
                percentProfit={financial_info.key_metrics.profit_forecast_percent.toFixed(1)}
                // @ts-ignore
                percentPlan={numberFormatter.formatNumber(
                    financial_info.key_metrics.planned_profit_percent.toFixed(1)
                )}
                valuePlan={formatPrice(
                    Math.round(financial_info?.key_metrics?.planned_profit_value),
                    {
                        withCurrency: true,
                        currencySign: financial_info?.currency?.sign,
                    }
                )}
                financialInfoType={FinancialInfoType.PROFIT_FORECAST}
                tooltipText={i18next.t(
                    'ProfitForecastInformationBlock.return.financialIndicatorsInfoElement.tooltipText'
                )}
            />
        </div>
    );
};
